import { bindSegmentTrackerStore } from '../../features/tracking/trackers/segmentTrackerReduxBridge';
import { setupStore } from './setup';

export const store = setupStore();
bindSegmentTrackerStore(store);
